module.exports = {
          srcSet: __webpack_public_path__ + "da56640a70de8fe5de7c18943c581949-564.png"+" 564w",
          images:[ {path: __webpack_public_path__ + "da56640a70de8fe5de7c18943c581949-564.png",width: 564,height: 318}],
          src: __webpack_public_path__ + "da56640a70de8fe5de7c18943c581949-564.png",
          toString:function(){return __webpack_public_path__ + "da56640a70de8fe5de7c18943c581949-564.png"},
          
          width: 564,
          height: 318
        }